<template>
    <v-card>
    <v-navigation-drawer
    v-model="right_drawer"
    app dark      
    right
    width="400px"
    >
      <template v-slot:prepend>
        <v-list-item >
          <!--
          <v-list-item-avatar>
            <img :src="entity_type_image">
          </v-list-item-avatar>
          -->
          <v-list-item-icon>
           <v-icon> mdi-plus-circle </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">Quiz Creation</v-list-item-title>
            
          </v-list-item-content>
           <v-btn
          icon
          @click.stop="close_right_sidebar" 
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        </v-list-item>
        
         <v-list-item >
        <v-breadcrumbs large dark :items="b_items">
       <template v-slot:divider>
        <v-icon>mdi-forward</v-icon>
      </template>
      <!--
      <template v-slot:item="{ item }">
      <v-breadcrumbs-item>
      <v-btn
      
      text
      :disabled="item.disabled"
      @click="redirect_to(item.href)"
      > {{ item.text }}
      </v-btn>
       </v-breadcrumbs-item>
     
    </template> -->
    </v-breadcrumbs>
     </v-list-item >  

      </template>

      <v-divider></v-divider>

  <template>
  <v-form
    class="mx-2"
    ref="form"
    v-model="valid"
    lazy-validation
  >
  

    
  <v-text-field
          :rules="scoreRules"
          class="mt-2"
          v-model="score"
          label="Quiz Score"
          max="10"
          min="1"
          step="1"
          style="width: 125px"
          type="number"
          @keydown="false">
    <template #label>
      <span class="red--text"><strong>* </strong></span>Quiz Score
    </template>
    </v-text-field>

   

    <v-textarea
          :rules="questionRules"
          name="input-7-1"
          v-model="question"
          hint="Insert here the quiz question"
          :counter="200">
      <template #label>
      <span class="red--text"><strong>* </strong></span>Quiz Question
    </template>
    </v-textarea>

     <v-select
        v-model="question_type"
        :items="question_types"
        label="Question Type"
        style="max-width: 250px;"
        
      ></v-select>

     <div v-if="question_type=='Multiple choice'">

     <v-text-field  v-for= "answer in answers" :key=answer.index 
       :append-outer-icon="answer.index > 2 ? 'mdi-minus' : ''"
       @click:append-outer="remove_answer(answer.index)"
      v-model="answer.value"
      :counter="200"
      :rules="answerRules"
      required >
      <template #label>
      <span class="red--text"><strong>* </strong></span>Answer {{answer.index}}
    </template>
    
    </v-text-field>

  
     
     <v-btn small color="success"
     @click="add_answer"
      
      
    >
      <v-icon small left>mdi-plus</v-icon>
      Add Answer
    </v-btn>
   
      

    

     <v-select
          class="mt-2"
          v-model="correct_answer"
          :items=" potential_answers_choice"
          append-icon="mdi-thumb-up"
          menu-props="auto"
          outlined
          required
          :rules="correctAnswerRules">
      <template #label>
      <span class="red--text"><strong>* </strong></span>Select the Correct Answer
    </template>
          
    </v-select>

    </div>

    <div v-else>
     <v-select
      class="mt-2"
      v-model="correct_answer"
      :items="yes_no_potential_answers_choice"
      append-icon="mdi-thumb-up"
      menu-props="auto"
      outlined
      required
      :rules="correctAnswerRules">
      <template #label>
      <span class="red--text"><strong>* </strong></span>Select the Correct Answer
    </template>
          
    </v-select>


    </div>

     <v-textarea
          
          label="Correct Answer Explanation"
          v-model="explanation"
          hint="Insert here the explanation for the Correct Answer"
          :counter="500"

    ></v-textarea>


     
    
   
<v-btn
      @click="store_quiz"
      :loading="waiting_for_storage"
      :disabled="waiting_for_storage"
      color="success"
      class="mr-6 white--text"
      
    >
     
      <v-icon left dark>mdi-content-save</v-icon> Store Quiz
    </v-btn>

   

    <v-btn
      color="error"
      class="mr-6"
      @click="reset"
    >
      <v-icon left dark>mdi-eraser</v-icon> Reset Form
      
    </v-btn>

   
  </v-form>
</template>
   
   

  

  

  

    </v-navigation-drawer>


    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :color="snackbar_color"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackbar_text }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

   


  </v-card>




</template>

<script>
    import { componentBus } from '../main';
    import axios from 'axios';
    import {  APIS_BASE_URL } from '../constants';
    export default {
        name: 'QuizAddition',
        data: function () {
            return {

        b_items: [
        {
          text: 'Project',
          disabled: false,
          //href: 'project_edit?uuid=765e40d1-d8b5-4037-b68f-2d80096d0b15',
          //link: true,
         // exact: true,
          to: ''
        },
        {
          text: 'POI',
          disabled: false,
          to: ''
          //href: 'breadcrumbs_link_1',
        },
        {
          text: 'Quiz Addition',
          disabled: true,
          href: '',
        },
      ],      
        activation_range: null,
        relevant_project: null,
        answers: [{index:1, value: null},{index: 2, value: null}],
        potential_answers_choice: [{ text: 'Answer 1', value: 1},{ text: 'Answer 2', value: 2}],

        yes_no_potential_answers_choice: [{ text: 'No', value: 1},{ text: 'Yes', value: 2}],


        question_types: ['Multiple choice','Yes/No'],
        question_type: 'Multiple choice',


        snackbar_color: '',
        mode: '',
        snackbar: false,
        snackbar_text: '',
        timeout: 4000,
        x: null,
        y: 'top',


      

      waiting_for_storage: false,
     
     
      entity_type_image: "nextGen_logo-simple.png",
      right_drawer: true,


      poi_uuid: null,



      valid: true,
      title: '',
      

     
      answerRules: [
       v => !!v || 'This field is required',
       v => (v && v.length <= 200) || 'Answers must be less than 200 characters',
       
      ],
      questionRules: [
       v => !!v || 'This field is required',
       v => (v && v.length <= 200) || 'The question must be less than 200 characters',
       
      ],
      correctAnswerRules:  [
       v => !!v || 'This field is required'
       
       
      ],
      scoreRules: [
        v => !!v || 'Score is required',
        
       
      ],
      /*
      explanationRules: [
        v => ( v.length <= 500) || 'The explanation must be less than 500 characters',
        
       
      ],
     
     */
    
    

      score: 1,
      question: null,
      //answers: [{ text: 'Answer A', value: 1},{ text: 'Answer B', value: 2},{text: 'Answer C', value: 3},{text: 'Answer D', value: 4}],
      first_answer: null,
      second_answer: null,
      third_answer: null,
      fourth_answer: null,
      correct_answer: null,
      explanation: null
      
                
            };
        },
       
        methods: {

		fetch_poi_details()
       {   
        
        var get_poi_url=APIS_BASE_URL+"/pois/"+this.poi_uuid+"/";
        var get_poi_url_encoded= encodeURI(get_poi_url);
   
        axios.get(get_poi_url_encoded)
                    .then(response => {
                    this.activation_range=response.data.activation_range;
                    })
                    .catch(error => console.log(error));

                    
      },

        redirect_to(x)
        {
         alert(x);
        },

        add_answer()
        {
        let previous_answers_counter= this.answers.length;
        this.answers.push({index: previous_answers_counter+1, value: null});
        this.potential_answers_choice.push({text: "Answer "+(previous_answers_counter+1), value: (previous_answers_counter+1)  });

        },  

        remove_answer(answer_index)
        {
         this.answers.splice(answer_index-1,1);
         this.potential_answers_choice.splice(answer_index-1,1);


         for (let i = answer_index-1; i < this.answers.length; i++) {
          this.answers[i].index=i+1;
         }

         for (let i = answer_index-1; i < this.potential_answers_choice.length; i++) {
          this.potential_answers_choice[i].text="Answer "+(i+1);
          this.potential_answers_choice[i].value=(i+1);

         }

        
      
        },

        close_right_sidebar () {
            this.right_drawer = false;

      },
      


        store_quiz()
        {
         
          let valid= this.$refs.form.validate();
        


          if( valid)    
          {
           this.waiting_for_storage=true;
           let store_quiz_url_query=APIS_BASE_URL+"/quiz/";
           let encoded_store_quiz_url_query= encodeURI(store_quiz_url_query);
           var payload = {

                    answers: this.question_type=="Multiple choice" ?  this.answers.map(  (item) => item.value) : ["No","Yes"],
   

                    score: this.score,
                    question: this.question,
                    //answer_a: this.first_answer,
                    //answer_b: this.second_answer,
                    //answer_c: this.third_answer,
                    //answer_d: this.fourth_answer,
                    correct_answer: this.correct_answer,
                    explanation: this.explanation,
                    published: true,
                    created_by: "aaabbbccc",
                    relevant_poi: this.poi_uuid,
                    question_type: this.question_type=="Multiple choice" ? 1 : 2
                
                   
                }

           
           axios.post(encoded_store_quiz_url_query, payload,
                    {
                     headers: { 'Content-Type' : 'application/json'}
                               
                        }).then(response => {
                            if (response.status == "200" || response.status == "201" ) {
                               this.waiting_for_storage=false;
                               this.snackbar_color="success";
                               this.snackbar_text="The Quiz has been successfully stored!"
                               this.snackbar=true;
                               
                               payload.id=response.data.id;
                               payload.uuid=response.data.quiz_uuid;
							   payload.relevant_project= this.relevant_project;
							   payload.range= this.activation_range;
							   payload.focus_on_pin=true;
                               componentBus.$emit('newly_created_quiz', payload);
                               this.right_drawer= false;
       
                    
                            }
                            else {
                      
                                this.waiting_for_storage=false;
                                this.snackbar_color="error";
                                this.snackbar_text="Problem with the Quiz storage..."
                                this.snackbar=true;
                            }
                            this.reset();
                    })
                    .catch(error => {
                        console.log(error);
                        this.waiting_for_storage=false;
                        this.snackbar_color="error";
                        this.snackbar_text="Problem with the Quiz storage..."
                        this.snackbar=true;
                    });


 
          }

        },

        

         
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },

      lose_right_sidebar () {
        this.right_drawer = false;

      }

           
        },
        mounted() {

          

          //componentBus.$emit('quiz_addition_update_navigation_bar', true);
		  this.poi_uuid= this.$route.query.poi_uuid;
		  this.fetch_poi_details();
          this.relevant_project= this.$route.query.project_uuid;
          this.b_items[1]['to']='poi_edit?poi_uuid='+this.poi_uuid+'&project_uuid='+this.relevant_project;
          this.b_items[0]['to']='project_edit?uuid='+this.relevant_project;
         // let payload= {};
         // payload["point_uuid"]=this.poi_uuid;
          //payload["relevant_project"]= this.$route.query.relevant_project;
          //componentBus.$emit('set_map_view', this.$route.query.poi_uuid);
         // componentBus.$emit('set_map_view', payload);
        
        },
        destroyed() {
           
          
   
        },
        computed: {
           
      
},
        
    };
</script>

<style scoped>
   
</style>
